import { IState } from "@/redux/store.types";
import { getValueState } from "@/redux/utils";

import { $TranslationsModuleName } from "./translations.types";

const getTranslations = (state?: IState): any => {
    if (!state) {
        return {};
    }
    return getValueState(state, $TranslationsModuleName)?.data;
};

const getTranslationsDebug = (state: IState): boolean => {
    return !!getValueState(state, $TranslationsModuleName)?.debug;
};

export { getTranslations, getTranslationsDebug };
